(() => {
  const handles = new Set(['sparkling-tart-cherry-citrus', 'sparkling-strawberry-lime', 'sparkling-blueberry-mango-lemonade', 'variety-pack']);
  const countPacks = cart => cart.items.reduce((n, item) => n + (item.selling_plan_allocation && handles.has(item.handle) ? item.quantity : 0), 0);
  const root = window.Shopify?.routes?.root || '/';
  let checking = false;
  let pending = 0;
  let changedAt = 0;
  document.addEventListener('vyv:cart-changing', () => pending++);
  document.addEventListener('vyv:cart-settled', () => pending = Math.max(0, pending - 1));
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items') && event.target.name === 'updates[]') changedAt = Date.now();
  }, true);
  const showError = message => {
    const notices = document.querySelectorAll('[data-vyv-subscription-notice]');
    notices.forEach(notice => {
      notice.hidden = false;
      notice.querySelector('[data-vyv-subscription-message]').textContent = message;
    });
    const visible = Array.from(notices).find(notice => notice.getClientRects().length);
    if (visible) { visible.focus(); visible.scrollIntoView({block: 'nearest'}); }
    else window.location.assign(root + 'cart');
  };
  async function checkAndContinue(proceed) {
    if (checking) return;
    checking = true;
    try {
      const started = Date.now();
      // Let debounced quantity changes finish before reading Shopify's cart.
      while (pending || Date.now() - changedAt < 450) {
        if (Date.now() - started > 10000) throw new Error('Cart update is still in progress. Please try again.');
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!response.ok) throw new Error('We could not check your cart. Please try again.');
      const count = countPacks(await response.json());
      if (count > 0 && count < 2) {
        document.querySelectorAll('[data-vyv-checkout]').forEach(button => { button.disabled = true; button.setAttribute('aria-disabled', 'true'); });
        showError('Your subscription box needs at least two 12-packs. Add one more to continue, or remove the remaining subscription pack.');
        return;
      }
      proceed();
    } catch (error) { showError(error.message); }
    finally { checking = false; }
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]');
    if (!control) return;
    event.preventDefault(); event.stopImmediatePropagation();
    checkAndContinue(() => window.location.assign(root + 'checkout'));
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.id !== 'cart' && !form.querySelector('[name="checkout"]')) return;
    if (event.submitter?.name === 'update') return;
    event.preventDefault(); event.stopImmediatePropagation();
    checkAndContinue(() => window.location.assign(root + 'checkout'));
  }, true);
})();
